module.exports = __webpack_public_path__ + "images/psp/FeaturedImages/wine-1.webp";